export async function appendInjectedContextLines(
  out: string[],
  inject: string[],
  maybeYield: () => Promise<void>,
  injectedTotal: { value: number },
): Promise<void> {
  for (const t of inject) {
    out.push(` ${t}`);
    injectedTotal.value++;
    await maybeYield();
  }
}
